module.exports = __webpack_public_path__ + "static/media/ic_feed_columns.0130ab27.svg";